export default __webpack_public_path__ + "static/drip-3c3ba8b4a38a876a79e0a72f87531eb3.svg";